import { defineStore } from 'pinia'

export const UseAppStore = defineStore('apps', {
    state: () => ({
        breadcrumbs: {
            dashboard: {
                label: "Dashboard",
                url: "/admin"
            }
        }
    }),
    getters: {
        getBreadcrumbs(){

        }
    },
    actions: {
        putBreadcrumbs(key, label, url) {
            this.breadcrumbs = {
                ...this.breadcrumbs,
                [key]: {
                    label,
                    url
                }
            }
        },
        resetBreadcrumbs(){
            this.breadcrumbs = {};
        }
    }
});
